import { Typography } from "@mui/material";

const PreferredResponseText = () => {
  return (
    <>
      <Typography variant="h6">Which response do you prefer?</Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 1.5 }}>
        Selecting a preferred response helps refine the model to better suit
        your needs.
      </Typography>
    </>
  );
};

export default PreferredResponseText;
